import { Route } from 'react-router-dom';
import { pages } from '../../../utils/common';
import AnalyticsView from './analytics.view';
import { ProtectedRoute } from '../../../components/rbac/ProtectedRoute';

const useAnalyticsRoutes = () => (
  <Route
    path={pages.analytics.path}
    element={
      <ProtectedRoute module="analytics" checkAnySubmodule>
        <AnalyticsView />
      </ProtectedRoute>
    }
  >
    <Route
      path={pages.analytics.path + '/:analyticsSubRouteId'}
      element={
        <ProtectedRoute module="analytics" checkAnySubmodule>
          <AnalyticsView />
        </ProtectedRoute>
      }
    />
  </Route>
);

export default useAnalyticsRoutes;
